<template>
  <img :src="failed || !src ? placeholder : src" :alt="alt"
    class="w-10 h-10 shrink-0 rounded-full object-cover object-center" @error="failed = true" />
</template>

<script setup>
import { ref, watch } from 'vue';
import placeholder from '@/assets/images/avatar.png';
const props = defineProps({ src: { type: String, default: '' }, alt: { type: String, default: '' } });
const failed = ref(false);
watch(() => props.src, () => { failed.value = false; });
</script>
